<template>
  <div class="trip-flight">
    <div>
      <div class="trip-flight-departure trip-flight-departure-search" v-if="showDepartureInput">
        <div class="trip-flight-departure-label">Search Departure Location</div>
        <div class="trip-flight-departure-label">Please input 3-digit preferred departure airport code (customize your
          flight)
        </div>
        <el-input
            placeholder="Departure Location"
            v-model.trim="departureLocation"
            v-bind:disabled="loader"
            v-bind:maxlength="3">
        </el-input>
      </div>
      <div class="trip-flight-departure" v-if="allFlights.length && showDepartureFilter">
        <div class="trip-flight-departure-label">Select departure location</div>
        <el-select v-model="departureLocation" placeholder="Select departure location" clearable>
          <el-option
              key=""
              value=""
              label="All">
          </el-option>
          <el-option
              v-for="departureLocation in departureLocations"
              v-if="departureLocation.value"
              v-bind:key="departureLocation.value"
              v-bind:value="departureLocation.value"
              v-bind:label="departureLocation.text">
          </el-option>
        </el-select>
      </div>
      <div class="trip-flight-way" v-if="showWay">
        <button
            v-on:click.stop.prevent="setWayType(wayTypeList.round)"
            v-bind:disabled="loader"
            v-bind:class="{active: selectedWayType(wayTypeList.round)}">
          Round-Trip
        </button>
        <button
            v-on:click.stop.prevent="setWayType(wayTypeList.one)"
            v-bind:disabled="loader"
            v-bind:class="{active: selectedWayType(wayTypeList.one)}">
          One-Way
        </button>
        <div>
          <input type="checkbox" v-bind:disabled="loader" v-model="flexibleDates">
          <label>Show Flexible Dates</label>
        </div>
      </div>
      <div class="trip-flight-sort" v-if="showSorting && flights.length">
        <div v-on:click.prevent="selectFilter(filter)" v-for="filter in filters">
          <span>{{ filter.title }}</span>
          <i class="fa" v-bind:class="filter.asc ? 'fa-angle-down' : 'fa-angle-up'"
             v-bind:style="{color: filter.active ? '' : 'transparent'}"></i>
        </div>
      </div>
      <div class="trip-flight-empty" v-if="flightSearchMessages.length">
        <div class="trip-flight-empty-item" v-for="flightSearchMessage in flightSearchMessages">
          {{ flightSearchMessage.text }}
        </div>
      </div>
      <div class="preloader" v-bind:class="{active: loader}"></div>
      <div class="trip-flight-list" v-if="flights.length">
        <div class="trip-flight-list-item" v-for="flight in paginatedflights">

          <div class="trip-flight-price">
            <button v-on:click.stop.prevent="selectFlight(flight)" class="trip-flight-price-select"
                    v-bind:class="{active: isSelectedFlight(flight)}">Select
            </button>
          </div>

          <div class="trip-flight-list-item-container">
            <div class="trip-flight-info" v-for="itinerary in flight.itineraries.slice(0,1)">

              <div class="trip-flight-info-date" v-if="showFlightDate">
                <div>{{ itinerary.date.weekDay }},</div>
                <div>{{ itinerary.date.month }} {{ itinerary.date.day }},</div>
                <div>{{ itinerary.date.year }}</div>
              </div>

              <div class="trip-flight-info-airport">
                <div class="trip-flight-info-airport-name">
                  <span style="white-space: nowrap;">{{
                      myGetAirportCityName(itinerary.departure.location)
                    }} Departure </span>
                </div>
              </div>

            </div>
          </div>
          <div class="trip-flight-price">
            <div class="trip-flight-price-value">{{ getSingleFlightPrice(flight.travellers) | price }}</div>


          </div>
        </div>
        <template v-if="showChangeByAirliners">
          <hr class="hr-divider">
          <div class="trip-flight-change-by-airliners">
            <el-switch v-model="changeByAirliners"></el-switch>
            <span class="trip-flight-change-by-airliners-label">Flights subject to change by airliners</span>
          </div>
        </template>
      </div>
      <div class="trip-flight-empty" v-else-if="!loader && !flightSearchMessages.length">
        <div class="trip-flight-empty-item">No flights found</div>
      </div>
    </div>
    <div class="trip-pagination" v-if="flights.length && pageCount > 1">
      <div class="trip-pagination-count">
        Show {{ currentMin }}-{{ currentMax }} of {{ flights.length }} results
      </div>
      <el-pagination
          layout="prev, pager, next"
          v-bind:current-page.sync="page"
          v-bind:page-size="5"
          v-bind:pager-count="5"
          v-bind:total="flights.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import FlightsDetails from './FlightsDetails.vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {
  AIRLINE_GETTER,
  AIRPORT_CITY_GETTER,
  AIRPORT_NAME_GETTER,
  DEPARTURE_ORIGIN_MUTATION,
  FLEXIBLE_DATES_MUTATION,
  FLIGHT_SEARCH_MESSAGES_GETTER,
  FLIGHTS_NAMESPACE,
  SEARCH_AIRLINES_ACTION,
  SEARCH_AIRPORTS_ACTION,
  SEARCH_FLIGHTS_ACTION,
  SELECT_FLIGHT_ACTION,
  SET_WAY_TYPE_ACTION,
  UPDATE_RECOMMENDED_ACTION
} from '../store/modules/flights';
import {LOADER_GETTER, LOADER_NAMESPACE} from '../store/modules/loader';
import flightService from '../services/flightService';
import {config, WAY_ONE, WAY_ROUND} from '../../services/configService';
import sortingMixin from '../mixins/sorting';
import priceMixin from '../mixins/price';
import '../../plugins/element-ui/input';
import '../../plugins/element-ui/select';
import '../../plugins/element-ui/switch';
import '../../plugins/element-ui/popover';
import '../../plugins/element-ui/pagination';

export default {
  name: 'flights',
  mixins: [
    priceMixin,
    sortingMixin
  ],
  components: {
    FlightsDetails
  },
  props: {
    searchable: {
      type: Boolean,
      default: true
    },
    showWay: {
      type: Boolean,
      default: true
    },
    showDepartureInput: {
      type: Boolean,
      default: true
    },
    showDepartureFilter: {
      type: Boolean,
      default: true
    },
    showSorting: {
      type: Boolean,
      default: true
    },
    showFlightDate: {
      type: Boolean,
      default: true
    },
    showChangeByAirliners: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      page: 1,
      size: 5,
      wayTypeList: {
        one: WAY_ONE,
        round: WAY_ROUND
      },
      changeByAirliners: false
    };
  },
  computed: {
    /**
     * Flights getters from vuex storage
     */
    ...mapGetters(FLIGHTS_NAMESPACE, [
      AIRLINE_GETTER,
      AIRPORT_CITY_GETTER,
      AIRPORT_NAME_GETTER,
      FLIGHT_SEARCH_MESSAGES_GETTER
    ]),
    /**
     * Loader getters from vuex storage
     */
    ...mapGetters(LOADER_NAMESPACE, [
      LOADER_GETTER
    ]),
    departureLocation: {
      /**
       * Get flight origin
       *
       * @return {string}
       */
      get() {
        return this.$store.state[FLIGHTS_NAMESPACE].departure.origin;
      },
      /**
       * Set flight origin
       *
       * @param {string} origin
       *
       * @return {void}
       */
      set(origin) {
        this[DEPARTURE_ORIGIN_MUTATION](origin);
      }
    },
    flexibleDates: {
      /**
       * Get flexible dates state
       *
       * @return {boolean}
       */
      get() {
        return this.$store.state[FLIGHTS_NAMESPACE].flexibleDates;
      },
      /**
       * Set flexible dates state
       *
       * @param {boolean} flexibleDates
       *
       * @return {void}
       */
      set(flexibleDates) {
        this[FLEXIBLE_DATES_MUTATION](flexibleDates);
      }
    },
    /**
     * Get page count
     *
     * @return {int}
     */
    pageCount() {
      return Math.ceil(this.sortedFlights.length / this.size);
    },
    /**
     * Get paginated flight list
     *
     * @return {Array}
     */
    paginatedflights() {
      const start = (this.page - 1) * this.size;
      return this.sortedFlights.slice(start, start + this.size);
    },
    /**
     * Get current min
     *
     * @return {int}
     */
    currentMin() {
      return (this.page * this.size - this.size) + 1;
    },
    /**
     * Get current max
     *
     * @return {int}
     */
    currentMax() {
      const currentMax = this.page * this.size;
      return currentMax > this.sortedFlights.length ? this.sortedFlights.length : currentMax;
    },
    /**
     * Get flights
     *
     * @return {Object}
     */
    flights() {
      const flights = this.allFlights;
      if (this.showDepartureFilter
          && this.departureLocation.length) {
        return flights.filter(flight => {
          let ok = false;
          flight.itineraries.forEach(itinerary => {
            if (this.departureLocation === itinerary.departure.location) {
              ok = true;
            }
          });
          return ok;
        });
      }
      return flights;
    },
    /**
     * Get all flights
     *
     * @return {Object}
     */
    allFlights() {
      if (this.searchable) {
        return this.$store.state[FLIGHTS_NAMESPACE].flights.searched;
      }
      return this.$store.state[FLIGHTS_NAMESPACE].flights.default;
    },
    /**
     * Get departure locations
     *
     * @return {Array}
     */
    departureLocations() {
      const departureLocations = [];
      this.allFlights.forEach(flight => {
        const itinerary = flight.itineraries[0];
        if (!departureLocations.find(item => item.value === itinerary.departure.location)) {
          departureLocations.push({
            value: itinerary.departure.location,
            text: flightService.getFormattedLocationByCode(itinerary.departure.location)
          });
        }
      });
      return departureLocations;
    },
    /**
     * Get search flights loader state
     *
     * @return {boolean}
     */
    loader() {
      return this[LOADER_GETTER](config.trip.route.search);
    }
  },
  methods: {
    /**
     * Actions from vuex storage
     */
    ...mapActions(FLIGHTS_NAMESPACE, [
      SET_WAY_TYPE_ACTION,
      SELECT_FLIGHT_ACTION,
      SEARCH_FLIGHTS_ACTION,
      UPDATE_RECOMMENDED_ACTION,
      SEARCH_AIRLINES_ACTION,
      SEARCH_AIRPORTS_ACTION
    ]),
    /**
     * Mutations from vuex storage
     */
    ...mapMutations(FLIGHTS_NAMESPACE, [
      FLEXIBLE_DATES_MUTATION,
      DEPARTURE_ORIGIN_MUTATION
    ]),
    /**
     * Get flight price
     *
     * @param {Array} travellers
     *
     * @return {int|float}
     */
    getFlightPrice(travellers) {
      return travellers.reduce((travellerAccumulator, traveller) => {
        return travellerAccumulator + traveller.totalPrice;
      }, 0);
    },

    getSingleFlightPrice(travellers) {
      return travellers.reduce((travellerAccumulator, traveller) => {
        return  traveller.totalPriceAmount;
      }, 0);
    },
    /**
     * Return true if selected flight group is matches with param
     *
     * @param {int} curFlight
     *
     * @return {boolean}
     */
    isSelectedFlight(curFlight) {
      if(!!curFlight && !!this.$store.state[FLIGHTS_NAMESPACE].flights.selected)
        return this.$store.state[FLIGHTS_NAMESPACE].flights.selected.index === curFlight.index;
      return false;
    },
    /**
     * Return true if selected way type is matches with param
     *
     * @param {string} wayType
     *
     * @return {boolean}
     */
    selectedWayType(wayType) {
      return this.$store.state[FLIGHTS_NAMESPACE].wayType === wayType;
    },

    myGetAirportCityName(iata) {
      if (iata === null || iata === undefined)
        return "N/A";

      let cityName = "";
      switch (iata) {

        case "AAT":
          cityName = "Altay";
          break;
        case "ABE":
          cityName = "Allentown";
          break;
        case "ABI":
          cityName = "Abilene";
          break;
        case "ABL":
          cityName = "Ambler";
          break;
        case "ABQ":
          cityName = "Albuquerque";
          break;
        case "ABR":
          cityName = "Aberdeen";
          break;
        case "ABY":
          cityName = "Albany";
          break;
        case "ACK":
          cityName = "Nantucket";
          break;
        case "ACT":
          cityName = "Waco";
          break;
        case "ACV":
          cityName = "Arcata CA";
          break;
        case "ACX":
          cityName = "Xingyi";
          break;
        case "ACY":
          cityName = "Atlantic City";
          break;
        case "ADK":
          cityName = "Adak Island";
          break;
        case "ADQ":
          cityName = "Kodiak";
          break;
        case "AEB":
          cityName = "Baise";
          break;
        case "AET":
          cityName = "Allakaket";
          break;
        case "AEX":
          cityName = "Alexandria";
          break;
        case "AGN":
          cityName = "Angoon";
          break;
        case "AGS":
          cityName = "Bush Field";
          break;
        case "AHN":
          cityName = "Athens";
          break;
        case "AIA":
          cityName = "Alliance";
          break;
        case "AIN":
          cityName = "Wainwright";
          break;
        case "AKB":
          cityName = "Atka";
          break;
        case "AKI":
          cityName = "Akiak";
          break;
        case "AKJ":
          cityName = "Asahikawa";
          break;
        case "AKK":
          cityName = "Akhiok";
          break;
        case "AKN":
          cityName = "King Salmon";
          break;
        case "AKP":
          cityName = "Anaktuvuk Pass";
          break;
        case "AKU":
          cityName = "Aksu";
          break;
        case "ALB":
          cityName = "Albany";
          break;
        case "ALO":
          cityName = "Waterloo";
          break;
        case "ALS":
          cityName = "Alamosa";
          break;
        case "ALW":
          cityName = "Walla Walla";
          break;
        case "AMA":
          cityName = "Amarillo";
          break;
        case "ANC":
          cityName = "Anchorage";
          break;
        case "ANI":
          cityName = "Aniak";
          break;
        case "ANV":
          cityName = "Anvik";
          break;
        case "AOJ":
          cityName = "Aomori";
          break;
        case "AOO":
          cityName = "Altoona";
          break;
        case "AOS":
          cityName = "Amook Bay";
          break;
        case "APF":
          cityName = "Naples";
          break;
        case "APN":
          cityName = "Alpena";
          break;
        case "AQG":
          cityName = "Anqing";
          break;
        case "ARC":
          cityName = "Arctic Village";
          break;
        case "ART":
          cityName = "Watertown";
          break;
        case "ASE":
          cityName = "Aspen";
          break;
        case "ASJ":
          cityName = "Amami";
          break;
        case "ATK":
          cityName = "Atqasuk";
          break;
        case "ATL":
          cityName = "Atlanta";
          break;
        case "ATT":
          cityName = "Austin TX";
          break;
        case "ATW":
          cityName = "Appleton";
          break;
        case "ATY":
          cityName = "Watertown";
          break;
        case "AUG":
          cityName = "Augusta";
          break;
        case "AUK":
          cityName = "Alakanuk";
          break;
        case "AUS":
          cityName = "Austin";
          break;
        case "AVL":
          cityName = "Asheville";
          break;
        case "AVP":
          cityName = "Scranton";
          break;
        case "AXT":
          cityName = "Akita";
          break;
        case "AZA":
          cityName = "Mesa";
          break;
        case "AZO":
          cityName = "Kalamazoo";
          break;
        case "BAV":
          cityName = "Baotou";
          break;
        case "BDL":
          cityName = "Windsor Locks";
          break;
        case "BET":
          cityName = "Bethel";
          break;
        case "BFD":
          cityName = "Bradford";
          break;
        case "BFF":
          cityName = "Scottsbluff";
          break;
        case "BFI":
          cityName = "Seattle";
          break;
        case "BFJ":
          cityName = "Bijie";
          break;
        case "BFL":
          cityName = "Bakersfield";
          break;
        case "BFV":
          cityName = "Buri Ram";
          break;
        case "BGM":
          cityName = "Binghamton";
          break;
        case "BGR":
          cityName = "Bangor";
          break;
        case "BHB":
          cityName = "Bar Harbor";
          break;
        case "BHM":
          cityName = "Birmingham";
          break;
        case "BHY":
          cityName = "Beihai";
          break;
        case "BIL":
          cityName = "Billings";
          break;
        case "BIS":
          cityName = "Bismarck";
          break;
        case "BJI":
          cityName = "Bemidji";
          break;
        case "BKC":
          cityName = "Buckland";
          break;
        case "BKG":
          cityName = "Branson";
          break;
        case "BKK":
          cityName = "Bangkok";
          break;
        case "BKW":
          cityName = "Beckley";
          break;
        case "BLD":
          cityName = "Boulder City";
          break;
        case "BLI":
          cityName = "Bellingham";
          break;
        case "BLV":
          cityName = "Belleville";
          break;
        case "BMI":
          cityName = "Bloomington";
          break;
        case "BMV":
          cityName = "Buonmethuot";
          break;
        case "BNA":
          cityName = "Nashville";
          break;
        case "BOI":
          cityName = "Boise";
          break;
        case "BOS":
          cityName = "Boston";
          break;
        case "BPT":
          cityName = "Beaumont";
          break;
        case "BPX":
          cityName = "Bangda";
          break;
        case "BQK":
          cityName = "Brunswick";
          break;
        case "BRD":
          cityName = "Brainerd";
          break;
        case "BRL":
          cityName = "Burlington";
          break;
        case "BRO":
          cityName = "Brownsville";
          break;
        case "BRW":
          cityName = "Barrow";
          break;
        case "BSD":
          cityName = "Baoshan";
          break;
        case "BTI":
          cityName = "Barter Island";
          break;
        case "BTM":
          cityName = "Butte";
          break;
        case "BTR":
          cityName = "Baton Rouge";
          break;
        case "BTT":
          cityName = "Bettles";
          break;
        case "BTV":
          cityName = "Burlington";
          break;
        case "BUF":
          cityName = "Buffalo";
          break;
        case "BUR":
          cityName = "Burbank";
          break;
        case "BWI":
          cityName = "Baltimore";
          break;
        case "BZN":
          cityName = "Bozeman";
          break;
        case "CAE":
          cityName = "Columbia";
          break;
        case "CAH":
          cityName = "Ca Mau";
          break;
        case "CAK":
          cityName = "Akron";
          break;
        case "CAN":
          cityName = "Guangzhou";
          break;
        case "CDB":
          cityName = "Cold Bay";
          break;
        case "CDC":
          cityName = "Cedar City";
          break;
        case "CDR":
          cityName = "Chadron";
          break;
        case "CDV":
          cityName = "Cordova";
          break;
        case "CEC":
          cityName = "Crescent City";
          break;
        case "CEI":
          cityName = "Chiang Rai";
          break;
        case "CEM":
          cityName = "Central";
          break;
        case "CEZ":
          cityName = "Cortez";
          break;
        case "CGA":
          cityName = "Craig";
          break;
        case "CGD":
          cityName = "Changde";
          break;
        case "CGI":
          cityName = "Cape Girardeau";
          break;
        case "CGO":
          cityName = "Zhengzhou";
          break;
        case "CGQ":
          cityName = "Changchun";
          break;
        case "CHA":
          cityName = "Chattanooga";
          break;
        case "CHG":
          cityName = "Chaoyang";
          break;
        case "CHO":
          cityName = "Charlottesville VA";
          break;
        case "CHS":
          cityName = "Charleston";
          break;
        case "CHU":
          cityName = "Chuathbaluk";
          break;
        case "CIC":
          cityName = "Chico";
          break;
        case "CID":
          cityName = "Cedar Rapids";
          break;
        case "CIF":
          cityName = "Chifeng";
          break;
        case "CIH":
          cityName = "Changzhi";
          break;
        case "CIK":
          cityName = "Chalkyitsik";
          break;
        case "CIU":
          cityName = "Sault Ste Marie";
          break;
        case "CJM":
          cityName = "Chumphon";
          break;
        case "CKB":
          cityName = "Clarksburg";
          break;
        case "CKD":
          cityName = "Crooked Creek";
          break;
        case "CKG":
          cityName = "Chongqing";
          break;
        case "CLD":
          cityName = "Carlsbad";
          break;
        case "CLE":
          cityName = "Cleveland";
          break;
        case "CLL":
          cityName = "College Station";
          break;
        case "CLM":
          cityName = "Port Angeles";
          break;
        case "CLT":
          cityName = "Charlotte";
          break;
        case "CMH":
          cityName = "Columbus";
          break;
        case "CMI":
          cityName = "Champaign";
          break;
        case "CMX":
          cityName = "Hancock";
          break;
        case "CNM":
          cityName = "Carlsbad";
          break;
        case "CNX":
          cityName = "Chiang Mai";
          break;
        case "CNY":
          cityName = "Moab";
          break;
        case "COD":
          cityName = "Cody";
          break;
        case "COS":
          cityName = "Colorado Springs";
          break;
        case "COU":
          cityName = "Columbia";
          break;
        case "CPR":
          cityName = "Casper";
          break;
        case "CRP":
          cityName = "Corpus Christi";
          break;
        case "CRW":
          cityName = "Charleston";
          break;
        case "CSG":
          cityName = "Columbus";
          break;
        case "CSX":
          cityName = "Changcha";
          break;
        case "CTS":
          cityName = "Sapporo";
          break;
        case "CTU":
          cityName = "Chengdu";
          break;
        case "CVG":
          cityName = "Cincinnati";
          break;
        case "CWA":
          cityName = "Wassau";
          break;
        case "CXF":
          cityName = "Coldfoot";
          break;
        case "CXR":
          cityName = "Nha Trang";
          break;
        case "CYF":
          cityName = "Chefornak";
          break;
        case "CYS":
          cityName = "Cheyenne";
          break;
        case "CZX":
          cityName = "Changzhou";
          break;
        case "DAB":
          cityName = "Daytona Beach";
          break;
        case "DAD":
          cityName = "Danang";
          break;
        case "DAL":
          cityName = "Dallas";
          break;
        case "DAT":
          cityName = "Datong";
          break;
        case "DAX":
          cityName = "Dazhou";
          break;
        case "DAY":
          cityName = "Dayton";
          break;
        case "DBQ":
          cityName = "Dubuque IA";
          break;
        case "DCA":
          cityName = "Washington";
          break;
        case "DCY":
          cityName = "Daocheng";
          break;
        case "DDC":
          cityName = "Dodge City";
          break;
        case "DDG":
          cityName = "Dandong";
          break;
        case "DEC":
          cityName = "Decatur";
          break;
        case "DEN":
          cityName = "Denver";
          break;
        case "DFW":
          cityName = "Dallas-Fort Worth";
          break;
        case "DHN":
          cityName = "Dothan";
          break;
        case "DIG":
          cityName = "Shangri-La";
          break;
        case "DIK":
          cityName = "Dickinson";
          break;
        case "DIN":
          cityName = "Dienbienphu";
          break;
        case "DLC":
          cityName = "Dalian";
          break;
        case "DLG":
          cityName = "Dillingham";
          break;
        case "DLH":
          cityName = "Duluth";
          break;
        case "DLI":
          cityName = "Dalat";
          break;
        case "DLU":
          cityName = "Dali";
          break;
        case "DMK":
          cityName = "Bangkok";
          break;
        case "DNH":
          cityName = "Dunhuang";
          break;
        case "DOY":
          cityName = "Dongying";
          break;
        case "DRG":
          cityName = "Deering";
          break;
        case "DRO":
          cityName = "Durango";
          break;
        case "DSM":
          cityName = "Des Moines";
          break;
        case "DSN":
          cityName = "Dongsheng";
          break;
        case "DTW":
          cityName = "Detroit";
          break;
        case "DUJ":
          cityName = "Du Bois";
          break;
        case "DUT":
          cityName = "Unalaska";
          break;
        case "DYG":
          cityName = "Dayong";
          break;
        case "EAR":
          cityName = "Kearney";
          break;
        case "EAT":
          cityName = "Wenatchee";
          break;
        case "EAU":
          cityName = "Eau Claire";
          break;
        case "ECP":
          cityName = "Panama City";
          break;
        case "EEK":
          cityName = "Eek";
          break;
        case "EGE":
          cityName = "Vail";
          break;
        case "EGX":
          cityName = "Egegik";
          break;
        case "EKO":
          cityName = "Elko";
          break;
        case "ELD":
          cityName = "El Dorado";
          break;
        case "ELI":
          cityName = "Elim";
          break;
        case "ELM":
          cityName = "Elmira";
          break;
        case "ELP":
          cityName = "El Paso";
          break;
        case "ELV":
          cityName = "Elfin Cove";
          break;
        case "EMK":
          cityName = "Emmonak";
          break;
        case "ENA":
          cityName = "Kenai";
          break;
        case "ENH":
          cityName = "Enshi";
          break;
        case "ENY":
          cityName = "Yan'an";
          break;
        case "ERI":
          cityName = "Erie";
          break;
        case "ESC":
          cityName = "Escanaba";
          break;
        case "ESD":
          cityName = "Eastsound";
          break;
        case "EUG":
          cityName = "Eugene";
          break;
        case "EVV":
          cityName = "Evansville";
          break;
        case "EWB":
          cityName = "New Bedford";
          break;
        case "EWN":
          cityName = "New Bern";
          break;
        case "EWR":
          cityName = "Newark";
          break;
        case "EXI":
          cityName = "Excursion Inlet";
          break;
        case "EYW":
          cityName = "Key West";
          break;
        case "FAI":
          cityName = "Fairbanks";
          break;
        case "FAR":
          cityName = "Fargo";
          break;
        case "FAT":
          cityName = "Fresno";
          break;
        case "FAY":
          cityName = "Fayetteville";
          break;
        case "FBS":
          cityName = "Friday Harbor";
          break;
        case "FCA":
          cityName = "Kalispell";
          break;
        case "FKL":
          cityName = "Franklin";
          break;
        case "FKS":
          cityName = "Fukushima";
          break;
        case "FLG":
          cityName = "Flagstaff";
          break;
        case "FLL":
          cityName = "Fort Lauderdale";
          break;
        case "FLO":
          cityName = "Florence";
          break;
        case "FMN":
          cityName = "Farmington";
          break;
        case "FNT":
          cityName = "Flint";
          break;
        case "FOC":
          cityName = "Fuzhou";
          break;
        case "FOE":
          cityName = "Topeka";
          break;
        case "FRD":
          cityName = "Friday Harbor";
          break;
        case "FSD":
          cityName = "Sioux Falls";
          break;
        case "FSM":
          cityName = "Fort Smith";
          break;
        case "FSZ":
          cityName = "Shizuoka";
          break;
        case "FUG":
          cityName = "Fuyang";
          break;
        case "FUJ":
          cityName = "Fukue";
          break;
        case "FUK":
          cityName = "Fukuoka";
          break;
        case "FUO":
          cityName = "Foshan";
          break;
        case "FWA":
          cityName = "Fort Wayne";
          break;
        case "FYU":
          cityName = "Fort Yukon";
          break;
        case "GAJ":
          cityName = "Yamagata";
          break;
        case "GAL":
          cityName = "Galena";
          break;
        case "GAM":
          cityName = "Gambell";
          break;
        case "GCC":
          cityName = "Gillette";
          break;
        case "GCK":
          cityName = "Garden City";
          break;
        case "GCN":
          cityName = "Grand Canyon";
          break;
        case "GCW":
          cityName = "Grand Canyon West";
          break;
        case "GDV":
          cityName = "Glendive";
          break;
        case "GEG":
          cityName = "Spokane";
          break;
        case "GFK":
          cityName = "Grand Forks";
          break;
        case "GGG":
          cityName = "Longview";
          break;
        case "GGW":
          cityName = "Glasgow";
          break;
        case "GJT":
          cityName = "Grand Junction";
          break;
        case "GLH":
          cityName = "Greenville";
          break;
        case "GLV":
          cityName = "Golovin";
          break;
        case "GNU":
          cityName = "Goodnews Bay";
          break;
        case "GNV":
          cityName = "Gainesville";
          break;
        case "GOQ":
          cityName = "Golmud";
          break;
        case "GPT":
          cityName = "Gulfport";
          break;
        case "GRB":
          cityName = "Green Bay";
          break;
        case "GRI":
          cityName = "Grand Island";
          break;
        case "GRK":
          cityName = "Killeen";
          break;
        case "GRR":
          cityName = "Grand Rapids";
          break;
        case "GSO":
          cityName = "Greensboro";
          break;
        case "GSP":
          cityName = "Greenville";
          break;
        case "GST":
          cityName = "Gustavus";
          break;
        case "GTF":
          cityName = "Great Falls";
          break;
        case "GTR":
          cityName = "Columbus Mississippi";
          break;
        case "GUC":
          cityName = "Gunnison";
          break;
        case "GXH":
          cityName = "Xiahe city";
          break;
        case "GYS":
          cityName = "Guangyuan";
          break;
        case "HAC":
          cityName = "Hachijojima";
          break;
        case "HAK":
          cityName = "Haikou";
          break;
        case "HAN":
          cityName = "Hanoi";
          break;
        case "HCR":
          cityName = "Holy Cross";
          break;
        case "HDG":
          cityName = "Handan";
          break;
        case "HDN":
          cityName = "Hayden";
          break;
        case "HDY":
          cityName = "Hat Yai";
          break;
        case "HEK":
          cityName = "Heihe";
          break;
        case "HET":
          cityName = "Hohhot";
          break;
        case "HFE":
          cityName = "Hefei";
          break;
        case "HGH":
          cityName = "Hangzhou";
          break;
        case "HGN":
          cityName = "Mae Hong Son";
          break;
        case "HGR":
          cityName = "Hagerstown";
          break;
        case "HHH":
          cityName = "Hilton Head";
          break;
        case "HIA":
          cityName = "Huai An";
          break;
        case "HIB":
          cityName = "Hibbing";
          break;
        case "HIJ":
          cityName = "Hiroshima";
          break;
        case "HJJ":
          cityName = "Zhijiang";
          break;
        case "HKB":
          cityName = "Healy";
          break;
        case "HKD":
          cityName = "Hakodate";
          break;
        case "HKT":
          cityName = "Phuket";
          break;
        case "HLD":
          cityName = "Hailar";
          break;
        case "HLH":
          cityName = "Ulanhot";
          break;
        case "HLN":
          cityName = "Helena";
          break;
        case "HMI":
          cityName = "Hami";
          break;
        case "HNA":
          cityName = "Hanamaki";
          break;
        case "HND":
          cityName = "Tokyo";
          break;
        case "HNH":
          cityName = "Hoonah";
          break;
        case "HNL":
          cityName = "Honolulu";
          break;
        case "HNM":
          cityName = "Hana";
          break;
        case "HNS":
          cityName = "Haines";
          break;
        case "HOB":
          cityName = "Hobbs";
          break;
        case "HOM":
          cityName = "Homer";
          break;
        case "HON":
          cityName = "Huron";
          break;
        case "HOT":
          cityName = "Hot Springs";
          break;
        case "HOU":
          cityName = "Houston";
          break;
        case "HPB":
          cityName = "Hooper Bay";
          break;
        case "HPH":
          cityName = "Haiphong";
          break;
        case "HPN":
          cityName = "White Plains";
          break;
        case "HRB":
          cityName = "Harbin";
          break;
        case "HRL":
          cityName = "Harlingen";
          break;
        case "HRO":
          cityName = "Harrison";
          break;
        case "HSG":
          cityName = "Saga";
          break;
        case "HSL":
          cityName = "Huslia";
          break;
        case "HSN":
          cityName = "Zhoushan";
          break;
        case "HSV":
          cityName = "Huntsville";
          break;
        case "HTN":
          cityName = "Hotan";
          break;
        case "HTS":
          cityName = "Huntington";
          break;
        case "HUI":
          cityName = "Hue";
          break;
        case "HUS":
          cityName = "Hughes";
          break;
        case "HVN":
          cityName = "New Haven";
          break;
        case "HVR":
          cityName = "Havre";
          break;
        case "HYA":
          cityName = "Barnstable";
          break;
        case "HYG":
          cityName = "Hydaburg";
          break;
        case "HYL":
          cityName = "Hollis";
          break;
        case "HYN":
          cityName = "Huangyan";
          break;
        case "HZH":
          cityName = "Liping";
          break;
        case "IAD":
          cityName = "Washington";
          break;
        case "IAG":
          cityName = "Niagara Falls";
          break;
        case "IAH":
          cityName = "Houston";
          break;
        case "IAN":
          cityName = "Kiana";
          break;
        case "IBR":
          cityName = "Ibaraki";
          break;
        case "ICT":
          cityName = "Wichita";
          break;
        case "IDA":
          cityName = "Idaho Falls";
          break;
        case "IGG":
          cityName = "Igiugig";
          break;
        case "IGM":
          cityName = "Kingman";
          break;
        case "IKI":
          cityName = "Iki";
          break;
        case "IKO":
          cityName = "Nikolski";
          break;
        case "ILG":
          cityName = "Wilmington";
          break;
        case "ILI":
          cityName = "Iliamna";
          break;
        case "ILM":
          cityName = "Wilmington";
          break;
        case "IMT":
          cityName = "Iron Mountain";
          break;
        case "INC":
          cityName = "Yinchuan";
          break;
        case "IND":
          cityName = "Indianapolis";
          break;
        case "INL":
          cityName = "International Falls";
          break;
        case "IPL":
          cityName = "Imperial";
          break;
        case "IPT":
          cityName = "Williamsport";
          break;
        case "IQN":
          cityName = "Qingyang";
          break;
        case "IRC":
          cityName = "Circle";
          break;
        case "IRK":
          cityName = "Kirksville";
          break;
        case "ISG":
          cityName = "Ishigaki";
          break;
        case "ISN":
          cityName = "Williston";
          break;
        case "ISP":
          cityName = "Islip";
          break;
        case "ITH":
          cityName = "Ithaca";
          break;
        case "ITM":
          cityName = "Osaka";
          break;
        case "ITO":
          cityName = "Hilo";
          break;
        case "IWJ":
          cityName = "Iwami";
          break;
        case "IZO":
          cityName = "Izumo";
          break;
        case "JAC":
          cityName = "Jacksn Hole";
          break;
        case "JAN":
          cityName = "Jackson";
          break;
        case "JAX":
          cityName = "Jacksonville";
          break;
        case "JBR":
          cityName = "Jonesboro";
          break;
        case "JDZ":
          cityName = "Jingdezhen";
          break;
        case "JFK":
          cityName = "New York";
          break;
        case "JGD":
          cityName = "Jiagedaqi District";
          break;
        case "JGN":
          cityName = "Jiayuguan";
          break;
        case "JGS":
          cityName = "Ji An";
          break;
        case "JHG":
          cityName = "Jinghong";
          break;
        case "JHM":
          cityName = "Lahania-kapalua";
          break;
        case "JHW":
          cityName = "Jamestown";
          break;
        case "JIQ":
          cityName = "Qianjiang";
          break;
        case "JIU":
          cityName = "Jiujiang";
          break;
        case "JJN":
          cityName = "Quanzhou";
          break;
        case "JLN":
          cityName = "Joplin";
          break;
        case "JMU":
          cityName = "Jiamusi";
          break;
        case "JNG":
          cityName = "Jining";
          break;
        case "JNU":
          cityName = "Juneau";
          break;
        case "JNZ":
          cityName = "Jinzhou";
          break;
        case "JST":
          cityName = "Johnstown";
          break;
        case "JUZ":
          cityName = "Quzhou";
          break;
        case "JXA":
          cityName = "Jixi";
          break;
        case "JZH":
          cityName = "Jiuzhaigou";
          break;
        case "KAE":
          cityName = "Kake";
          break;
        case "KAL":
          cityName = "Kaltag";
          break;
        case "KBC":
          cityName = "Brich Creek";
          break;
        case "KBV":
          cityName = "Krabi";
          break;
        case "KCA":
          cityName = "Kuqa";
          break;
        case "KCC":
          cityName = "Coffman Cove";
          break;
        case "KCL":
          cityName = "Chignik Lagoon";
          break;
        case "KCQ":
          cityName = "Chignik Lake";
          break;
        case "KCZ":
          cityName = "Kochi";
          break;
        case "KFP":
          cityName = "False Pass";
          break;
        case "KGT":
          cityName = "Kangding";
          break;
        case "KGX":
          cityName = "Grayling";
          break;
        case "KHG":
          cityName = "Kashi";
          break;
        case "KHN":
          cityName = "Nanchang";
          break;
        case "KIJ":
          cityName = "Niigata";
          break;
        case "KIX":
          cityName = "Osaka";
          break;
        case "KKA":
          cityName = "Koyuk";
          break;
        case "KKB":
          cityName = "Kitoi Bay";
          break;
        case "KKC":
          cityName = "Khon Kaen";
          break;
        case "KKH":
          cityName = "Kongiganak";
          break;
        case "KKJ":
          cityName = "Kitakyushu";
          break;
        case "KLG":
          cityName = "Kalskag";
          break;
        case "KLL":
          cityName = "Levelock";
          break;
        case "KLN":
          cityName = "Larsen Bay";
          break;
        case "KLW":
          cityName = "Klawock";
          break;
        case "KMG":
          cityName = "Kunming";
          break;
        case "KMI":
          cityName = "Miyazaki";
          break;
        case "KMJ":
          cityName = "Kumamoto";
          break;
        case "KMQ":
          cityName = "Kanazawa";
          break;
        case "KOA":
          cityName = "Kona";
          break;
        case "KOJ":
          cityName = "Kagoshima";
          break;
        case "KOP":
          cityName = "Nakhon Phanom";
          break;
        case "KOT":
          cityName = "Kotlik";
          break;
        case "KOW":
          cityName = "Ganzhou";
          break;
        case "KOZ":
          cityName = "Ouzinkie";
          break;
        case "KPB":
          cityName = "Point Baker";
          break;
        case "KPN":
          cityName = "Kipnuk";
          break;
        case "KPR":
          cityName = "Port Williams";
          break;
        case "KPV":
          cityName = "Perryville";
          break;
        case "KQA":
          cityName = "Akutan";
          break;
        case "KRL":
          cityName = "Korla";
          break;
        case "KRY":
          cityName = "Karamay";
          break;
        case "KSM":
          cityName = "St Mary's";
          break;
        case "KTB":
          cityName = "Thorne Bay";
          break;
        case "KTN":
          cityName = "Ketchikan";
          break;
        case "KTS":
          cityName = "Brevig Mission";
          break;
        case "KUH":
          cityName = "Kushiro";
          break;
        case "KUK":
          cityName = "Kasigluk";
          break;
        case "KVC":
          cityName = "King Cove";
          break;
        case "KVL":
          cityName = "Kivalina";
          break;
        case "KWE":
          cityName = "Guiyang";
          break;
        case "KWK":
          cityName = "Kwigillingok";
          break;
        case "KWL":
          cityName = "Guilin";
          break;
        case "KWN":
          cityName = "Quinhagak";
          break;
        case "KWT":
          cityName = "Kwethluk";
          break;
        case "KYK":
          cityName = "Karluk";
          break;
        case "KYU":
          cityName = "Koyukuk";
          break;
        case "KZB":
          cityName = "Zachar Bay";
          break;
        case "LAM":
          cityName = "Los Alamos";
          break;
        case "LAN":
          cityName = "Lansing";
          break;
        case "LAR":
          cityName = "Laramie";
          break;
        case "LAS":
          cityName = "Las Vegas";
          break;
        case "LAW":
          cityName = "Lawton";
          break;
        case "LAX":
          cityName = "Los Angeles";
          break;
        case "LBB":
          cityName = "Lubbock";
          break;
        case "LBE":
          cityName = "Latrobe";
          break;
        case "LBF":
          cityName = "North Platte";
          break;
        case "LBL":
          cityName = "Liberal";
          break;
        case "LCH":
          cityName = "Lake Charles";
          break;
        case "LCK":
          cityName = "Columbus";
          break;
        case "LCX":
          cityName = "Longyan";
          break;
        case "LEB":
          cityName = "Lebanon";
          break;
        case "LEX":
          cityName = "Lexington KY";
          break;
        case "LFT":
          cityName = "Lafayette";
          break;
        case "LGA":
          cityName = "New York";
          break;
        case "LGB":
          cityName = "Long Beach";
          break;
        case "LHW":
          cityName = "Lanzhou";
          break;
        case "LIH":
          cityName = "Lihue";
          break;
        case "LIT":
          cityName = "Little Rock";
          break;
        case "LJG":
          cityName = "Lijiang";
          break;
        case "LKE":
          cityName = "Seattle";
          break;
        case "LLF":
          cityName = "Yongzhou";
          break;
        case "LMT":
          cityName = "Klamath Falls";
          break;
        case "LNJ":
          cityName = "Lincang";
          break;
        case "LNK":
          cityName = "Lincoln";
          break;
        case "LNS":
          cityName = "Lancaster";
          break;
        case "LNY":
          cityName = "Lanai";
          break;
        case "LOE":
          cityName = "Loei";
          break;
        case "LPS":
          cityName = "Lopez";
          break;
        case "LPT":
          cityName = "Lampang";
          break;
        case "LRD":
          cityName = "Laredo";
          break;
        case "LSE":
          cityName = "La Crosse";
          break;
        case "LUK":
          cityName = "Cincinnati";
          break;
        case "LUM":
          cityName = "Luxi";
          break;
        case "LUR":
          cityName = "Cape Lisburne";
          break;
        case "LWB":
          cityName = "Lewisburg";
          break;
        case "LWS":
          cityName = "Lewiston";
          break;
        case "LXA":
          cityName = "Lhasa";
          break;
        case "LYA":
          cityName = "Luoyang";
          break;
        case "LYG":
          cityName = "Lianyungang";
          break;
        case "LYH":
          cityName = "Lynchburg";
          break;
        case "LYI":
          cityName = "Linyi";
          break;
        case "LZH":
          cityName = "Liuzhou";
          break;
        case "LZO":
          cityName = "Luzhou";
          break;
        case "LZY":
          cityName = "Nyingchi";
          break;
        case "MAF":
          cityName = "Midland";
          break;
        case "MAQ":
          cityName = "Tak";
          break;
        case "MBE":
          cityName = "Monbetsu";
          break;
        case "MBL":
          cityName = "Manistee";
          break;
        case "MBS":
          cityName = "Saginaw";
          break;
        case "MCE":
          cityName = "Merced";
          break;
        case "MCG":
          cityName = "Mcgrath";
          break;
        case "MCI":
          cityName = "Kansas City";
          break;
        case "MCK":
          cityName = "McCook";
          break;
        case "MCN":
          cityName = "Macon";
          break;
        case "MCO":
          cityName = "Orlando";
          break;
        case "MDG":
          cityName = "Mudanjiang";
          break;
        case "MDT":
          cityName = "Harrisburg";
          break;
        case "MDW":
          cityName = "Chicago";
          break;
        case "MEI":
          cityName = "Meridian";
          break;
        case "MEM":
          cityName = "Memphis";
          break;
        case "MFE":
          cityName = "Mcallen";
          break;
        case "MFR":
          cityName = "Medford";
          break;
        case "MGM":
          cityName = "MONTGOMERY";
          break;
        case "MGW":
          cityName = "Morgantown";
          break;
        case "MHK":
          cityName = "Manhattan";
          break;
        case "MHT":
          cityName = "Manchester NH";
          break;
        case "MIA":
          cityName = "Miami";
          break;
        case "MIG":
          cityName = "Mianyang";
          break;
        case "MKE":
          cityName = "Milwaukee";
          break;
        case "MKG":
          cityName = "Muskegon";
          break;
        case "MKK":
          cityName = "Molokai";
          break;
        case "MKL":
          cityName = "Jackson";
          break;
        case "MLB":
          cityName = "Melbourne";
          break;
        case "MLI":
          cityName = "Moline";
          break;
        case "MLL":
          cityName = "Marshall";
          break;
        case "MLU":
          cityName = "Monroe";
          break;
        case "MLY":
          cityName = "Manley Hot Springs";
          break;
        case "MMB":
          cityName = "Memanbetsu";
          break;
        case "MMH":
          cityName = "Mammoth Lakes";
          break;
        case "MMJ":
          cityName = "Matsumoto";
          break;
        case "MMU":
          cityName = "Morristown";
          break;
        case "MMY":
          cityName = "Miyako";
          break;
        case "MNT":
          cityName = "Minto";
          break;
        case "MOB":
          cityName = "Mobile";
          break;
        case "MOD":
          cityName = "Modesto";
          break;
        case "MOT":
          cityName = "Minot";
          break;
        case "MOU":
          cityName = "Mountain Village";
          break;
        case "MQT":
          cityName = "Marquette";
          break;
        case "MRY":
          cityName = "Monterey";
          break;
        case "MSJ":
          cityName = "Misawa";
          break;
        case "MSL":
          cityName = "Muscle Shoals";
          break;
        case "MSN":
          cityName = "Madison";
          break;
        case "MSO":
          cityName = "Missoula";
          break;
        case "MSP":
          cityName = "Minneapolis";
          break;
        case "MSS":
          cityName = "Massena";
          break;
        case "MSY":
          cityName = "New Orleans";
          break;
        case "MTJ":
          cityName = "Montrose CO";
          break;
        case "MTM":
          cityName = "Metakatla";
          break;
        case "MUE":
          cityName = "Kamuela";
          break;
        case "MVY":
          cityName = "Vineyard Haven MA";
          break;
        case "MWA":
          cityName = "Marion";
          break;
        case "MXZ":
          cityName = "Meixian";
          break;
        case "MYJ":
          cityName = "Matsuyama";
          break;
        case "MYR":
          cityName = "Myrtle Beach";
          break;
        case "MYU":
          cityName = "Mekoryuk";
          break;
        case "NAO":
          cityName = "Nanchong";
          break;
        case "NAW":
          cityName = "Narathiwat";
          break;
        case "NAY":
          cityName = "Beijing";
          break;
        case "NBS":
          cityName = "Baishan";
          break;
        case "NDG":
          cityName = "Qiqihar";
          break;
        case "NGB":
          cityName = "Ninbo";
          break;
        case "NGO":
          cityName = "Nagoya";
          break;
        case "NGQ":
          cityName = "Shiquanhe";
          break;
        case "NGS":
          cityName = "Nagasaki";
          break;
        case "NIB":
          cityName = "Nikolai";
          break;
        case "NKG":
          cityName = "Nanjing";
          break;
        case "NKM":
          cityName = "Nagoya";
          break;
        case "NLG":
          cityName = "Nelson Lagoon";
          break;
        case "NME":
          cityName = "Nightmute";
          break;
        case "NNG":
          cityName = "Nanning";
          break;
        case "NNT":
          cityName = "Nan";
          break;
        case "NNY":
          cityName = "Nanyang";
          break;
        case "NRT":
          cityName = "Tokyo";
          break;
        case "NST":
          cityName = "Nakhon Si Thammarat";
          break;
        case "NTG":
          cityName = "Nantong";
          break;
        case "NTQ":
          cityName = "Wajima";
          break;
        case "NUI":
          cityName = "Nuiqsut";
          break;
        case "NUL":
          cityName = "Nulato";
          break;
        case "NUP":
          cityName = "Nunapitchuk";
          break;
        case "NZH":
          cityName = "Manzhouli";
          break;
        case "OAJ":
          cityName = "Jacksonville NC";
          break;
        case "OAK":
          cityName = "Oakland";
          break;
        case "OBO":
          cityName = "Obihiro";
          break;
        case "OBU":
          cityName = "Kobuk";
          break;
        case "OGG":
          cityName = "Kahului";
          break;
        case "OGS":
          cityName = "Ogdensburg";
          break;
        case "OHE":
          cityName = "Mohe County";
          break;
        case "OIM":
          cityName = "Oshima";
          break;
        case "OIT":
          cityName = "Oita";
          break;
        case "OKA":
          cityName = "Okinawa";
          break;
        case "OKC":
          cityName = "Oklahoma City";
          break;
        case "OKJ":
          cityName = "Okayama";
          break;
        case "OLF":
          cityName = "Wolf Point";
          break;
        case "OLH":
          cityName = "Old Harbor";
          break;
        case "OMA":
          cityName = "Omaha";
          break;
        case "OME":
          cityName = "Nome";
          break;
        case "ONJ":
          cityName = "Odate Noshiro";
          break;
        case "ONT":
          cityName = "Ontario";
          break;
        case "OOK":
          cityName = "Toksook Bay";
          break;
        case "ORD":
          cityName = "Chicago";
          break;
        case "ORF":
          cityName = "Norfolk";
          break;
        case "ORH":
          cityName = "Worcester";
          break;
        case "ORI":
          cityName = "Port Lions";
          break;
        case "ORV":
          cityName = "Noorvik";
          break;
        case "OTH":
          cityName = "North Bend";
          break;
        case "OTZ":
          cityName = "Kotzebue";
          break;
        case "OWB":
          cityName = "Owensboro";
          break;
        case "PAH":
          cityName = "PADUCAH";
          break;
        case "PBG":
          cityName = "Plattsburgh";
          break;
        case "PBI":
          cityName = "West Palm Beach";
          break;
        case "PDT":
          cityName = "Pendleton";
          break;
        case "PDX":
          cityName = "Portland";
          break;
        case "PEC":
          cityName = "Pelican";
          break;
        case "PEK":
          cityName = "Beijing";
          break;
        case "PGA":
          cityName = "Page";
          break;
        case "PGD":
          cityName = "Punta Gorda";
          break;
        case "PGV":
          cityName = "Greenville";
          break;
        case "PHF":
          cityName = "Newport News";
          break;
        case "PHL":
          cityName = "Philadelphia";
          break;
        case "PHO":
          cityName = "Point Hope";
          break;
        case "PHS":
          cityName = "Phitsanulok";
          break;
        case "PHX":
          cityName = "Phoenix";
          break;
        case "PIA":
          cityName = "Peoria";
          break;
        case "PIB":
          cityName = "Hattiesburg/Laurel";
          break;
        case "PIE":
          cityName = "St. Petersburg";
          break;
        case "PIH":
          cityName = "Pocatello";
          break;
        case "PIP":
          cityName = "Pilot Point";
          break;
        case "PIR":
          cityName = "Pierre";
          break;
        case "PIT":
          cityName = "Pittsburgh";
          break;
        case "PIZ":
          cityName = "Point Lay";
          break;
        case "PKB":
          cityName = "PARKERSBURG";
          break;
        case "PLN":
          cityName = "Pellston";
          break;
        case "PNS":
          cityName = "Pensacola";
          break;
        case "PPV":
          cityName = "Port Protection";
          break;
        case "PQC":
          cityName = "Phu Quoc";
          break;
        case "PQI":
          cityName = "Presque Isle";
          break;
        case "PQS":
          cityName = "Pilot Station";
          break;
        case "PRC":
          cityName = "Prescott";
          break;
        case "PRH":
          cityName = "Phrae";
          break;
        case "PSC":
          cityName = "Pasco";
          break;
        case "PSG":
          cityName = "Petersburg";
          break;
        case "PSM":
          cityName = "Portsmouth";
          break;
        case "PSP":
          cityName = "Palm Springs";
          break;
        case "PTH":
          cityName = "Port Heiden";
          break;
        case "PTU":
          cityName = "Port Moller";
          break;
        case "PUB":
          cityName = "Pueblo";
          break;
        case "PUW":
          cityName = "Pullman";
          break;
        case "PVC":
          cityName = "Provincetown";
          break;
        case "PVD":
          cityName = "Providence";
          break;
        case "PVG":
          cityName = "Shanghai";
          break;
        case "PVU":
          cityName = "Provo";
          break;
        case "PWM":
          cityName = "Portland";
          break;
        case "PXU":
          cityName = "Pleiku";
          break;
        case "PYY":
          cityName = "Pai";
          break;
        case "PZI":
          cityName = "Panzhihua";
          break;
        case "RAP":
          cityName = "Rapid City";
          break;
        case "RBY":
          cityName = "Ruby";
          break;
        case "RCE":
          cityName = "Roche Harbor";
          break;
        case "RDD":
          cityName = "Redding";
          break;
        case "RDM":
          cityName = "Redmond-Bend";
          break;
        case "RDU":
          cityName = "Raleigh-durham";
          break;
        case "RDV":
          cityName = "Red Devil";
          break;
        case "RFD":
          cityName = "Rockford";
          break;
        case "RHI":
          cityName = "Rhinelander";
          break;
        case "RIC":
          cityName = "Richmond";
          break;
        case "RIW":
          cityName = "Riverton WY";
          break;
        case "RKD":
          cityName = "Rockland";
          break;
        case "RKS":
          cityName = "Rock Springs";
          break;
        case "RLK":
          cityName = "Bayannur";
          break;
        case "RMP":
          cityName = "Rampart";
          break;
        case "RNO":
          cityName = "Reno";
          break;
        case "ROA":
          cityName = "Roanoke VA";
          break;
        case "ROC":
          cityName = "Rochester";
          break;
        case "ROI":
          cityName = "Roi Et";
          break;
        case "ROW":
          cityName = "Roswell";
          break;
        case "RSH":
          cityName = "Russian Mission";
          break;
        case "RST":
          cityName = "Rochester";
          break;
        case "RSW":
          cityName = "Fort Myers";
          break;
        case "RUT":
          cityName = "Rutland";
          break;
        case "SAF":
          cityName = "Santa Fe";
          break;
        case "SAN":
          cityName = "San Diego";
          break;
        case "SAT":
          cityName = "San Antonio";
          break;
        case "SAV":
          cityName = "Savannah";
          break;
        case "SBA":
          cityName = "Santa Barbara";
          break;
        case "SBN":
          cityName = "South Bend";
          break;
        case "SBP":
          cityName = "San Luis Obispo";
          break;
        case "SBY":
          cityName = "Salisbury";
          break;
        case "SCC":
          cityName = "Deadhorse";
          break;
        case "SCE":
          cityName = "State College Pennsylvania";
          break;
        case "SCK":
          cityName = "Stockton";
          break;
        case "SCM":
          cityName = "Scammon Bay";
          break;
        case "SDF":
          cityName = "Louisville";
          break;
        case "SDJ":
          cityName = "Sendai";
          break;
        case "SDP":
          cityName = "Sand Point";
          break;
        case "SDY":
          cityName = "Sidney";
          break;
        case "SEA":
          cityName = "Seattle";
          break;
        case "SFB":
          cityName = "Sanford";
          break;
        case "SFO":
          cityName = "San Francisco";
          break;
        case "SGF":
          cityName = "Springfield";
          break;
        case "SGN":
          cityName = "Ho Chi Minh City";
          break;
        case "SGU":
          cityName = "Saint George";
          break;
        case "SGY":
          cityName = "Skagway";
          break;
        case "SHA":
          cityName = "Shanghai";
          break;
        case "SHB":
          cityName = "Nakashibetsu";
          break;
        case "SHD":
          cityName = "Weyers Cave";
          break;
        case "SHE":
          cityName = "Shenyang";
          break;
        case "SHG":
          cityName = "Shungnak";
          break;
        case "SHH":
          cityName = "Shishmaref";
          break;
        case "SHM":
          cityName = "Nanki-shirahama";
          break;
        case "SHP":
          cityName = "Qinhuangdao";
          break;
        case "SHR":
          cityName = "Sheridan";
          break;
        case "SHV":
          cityName = "Shreveport";
          break;
        case "SHX":
          cityName = "Shageluk";
          break;
        case "SIT":
          cityName = "Sitka";
          break;
        case "SJC":
          cityName = "San Jose";
          break;
        case "SJT":
          cityName = "San Angelo";
          break;
        case "SJW":
          cityName = "Shijiazhuang";
          break;
        case "SKK":
          cityName = "Shaktoolik";
          break;
        case "SLC":
          cityName = "Salt Lake City";
          break;
        case "SLK":
          cityName = "Saranac Lake";
          break;
        case "SLN":
          cityName = "Salina";
          break;
        case "SLQ":
          cityName = "Sleetmute";
          break;
        case "SMF":
          cityName = "Sacramento";
          break;
        case "SMK":
          cityName = "St. Michael";
          break;
        case "SMX":
          cityName = "Santa Maria";
          break;
        case "SNA":
          cityName = "Santa Ana";
          break;
        case "SNO":
          cityName = "Sakon Nakhon";
          break;
        case "SNP":
          cityName = "St. Paul Island";
          break;
        case "SOW":
          cityName = "Show Low";
          break;
        case "SPB":
          cityName = "San Luis";
          break;
        case "SPI":
          cityName = "Springfield";
          break;
        case "SPS":
          cityName = "Wichita Falls";
          break;
        case "SRQ":
          cityName = "Sarasota";
          break;
        case "SRV":
          cityName = "Stony River";
          break;
        case "STC":
          cityName = "Saint Cloud";
          break;
        case "STG":
          cityName = "St. George";
          break;
        case "STL":
          cityName = "St. Louis";
          break;
        case "STS":
          cityName = "Santa Rosa";
          break;
        case "SUX":
          cityName = "Sioux City";
          break;
        case "SVA":
          cityName = "Savoonga";
          break;
        case "SVC":
          cityName = "Silver City";
          break;
        case "SWA":
          cityName = "Shantou";
          break;
        case "SWF":
          cityName = "Newburgh";
          break;
        case "SXP":
          cityName = "Nunam Iqua";
          break;
        case "SYB":
          cityName = "Seal Bay";
          break;
        case "SYM":
          cityName = "Simao";
          break;
        case "SYO":
          cityName = "Shonai";
          break;
        case "SYR":
          cityName = "Syracuse";
          break;
        case "SYX":
          cityName = "Sanya";
          break;
        case "SZX":
          cityName = "Shenzhen";
          break;
        case "TAK":
          cityName = "Takamatsu";
          break;
        case "TAL":
          cityName = "Tanana";
          break;
        case "TAO":
          cityName = "Qingdao";
          break;
        case "TBB":
          cityName = "Tuy Hoa";
          break;
        case "TBN":
          cityName = "Fort Leonardwood";
          break;
        case "TCG":
          cityName = "Tacheng";
          break;
        case "TCT":
          cityName = "Takotna";
          break;
        case "TCZ":
          cityName = "Tengchong";
          break;
        case "TDX":
          cityName = "Trat";
          break;
        case "TEB":
          cityName = "Teterboro";
          break;
        case "TEN":
          cityName = "Tongren";
          break;
        case "TGO":
          cityName = "Tongliao";
          break;
        case "THD":
          cityName = "Thanh Hoa";
          break;
        case "THS":
          cityName = "Sukhothai";
          break;
        case "TKE":
          cityName = "Tenakee Springs";
          break;
        case "TKS":
          cityName = "Tokushima";
          break;
        case "TLA":
          cityName = "Teller";
          break;
        case "TLH":
          cityName = "Tallahassee";
          break;
        case "TLJ":
          cityName = "Tatalina";
          break;
        case "TLT":
          cityName = "Tuluksak";
          break;
        case "TNA":
          cityName = "Jinan";
          break;
        case "TNC":
          cityName = "Tin City";
          break;
        case "TNK":
          cityName = "Tununak";
          break;
        case "TOG":
          cityName = "Togiak Village";
          break;
        case "TOL":
          cityName = "Toledo";
          break;
        case "TOY":
          cityName = "Toyama";
          break;
        case "TPA":
          cityName = "Tampa";
          break;
        case "TRI":
          cityName = "BRISTOL";
          break;
        case "TSJ":
          cityName = "Tsushima";
          break;
        case "TSN":
          cityName = "Tianjin";
          break;
        case "TST":
          cityName = "Trang";
          break;
        case "TTJ":
          cityName = "Tottori";
          break;
        case "TTN":
          cityName = "Trenton";
          break;
        case "TUL":
          cityName = "Tulsa";
          break;
        case "TUP":
          cityName = "Tupelo";
          break;
        case "TUS":
          cityName = "Tucson";
          break;
        case "TVC":
          cityName = "Traverse City";
          break;
        case "TVF":
          cityName = "Thief River Falls";
          break;
        case "TVS":
          cityName = "Tangshan";
          break;
        case "TWF":
          cityName = "Twin Falls";
          break;
        case "TXK":
          cityName = "Texarkana";
          break;
        case "TXN":
          cityName = "Huangshan";
          break;
        case "TYN":
          cityName = "Taiyuan";
          break;
        case "TYR":
          cityName = "Tyler";
          break;
        case "TYS":
          cityName = "Knoxville";
          break;
        case "UBJ":
          cityName = "Yamaguchi";
          break;
        case "UBP":
          cityName = "Ubon Ratchathani";
          break;
        case "UEO":
          cityName = "Kumejima";
          break;
        case "UIH":
          cityName = "Phucat";
          break;
        case "UIN":
          cityName = "Quincy";
          break;
        case "UKB":
          cityName = "Kobe";
          break;
        case "UNK":
          cityName = "Unalakleet";
          break;
        case "UNN":
          cityName = "Ranong";
          break;
        case "URC":
          cityName = "Urumqi";
          break;
        case "URT":
          cityName = "Surat Thani";
          break;
        case "USM":
          cityName = "Ko Samui";
          break;
        case "UST":
          cityName = "St. Augustine Airport";
          break;
        case "UTH":
          cityName = "Udon Thani";
          break;
        case "UTP":
          cityName = "Pattaya";
          break;
        case "UYN":
          cityName = "Yulin";
          break;
        case "VAK":
          cityName = "Chevak";
          break;
        case "VCA":
          cityName = "Can Tho";
          break;
        case "VCL":
          cityName = "Chu Lai";
          break;
        case "VCS":
          cityName = "Conson";
          break;
        case "VCT":
          cityName = "Victoria";
          break;
        case "VDH":
          cityName = "Dong Hoi";
          break;
        case "VDZ":
          cityName = "Valdez";
          break;
        case "VEE":
          cityName = "Venetie";
          break;
        case "VEL":
          cityName = "Vernal";
          break;
        case "VII":
          cityName = "Vinh";
          break;
        case "VIS":
          cityName = "Visalia";
          break;
        case "VKG":
          cityName = "Rach Gia";
          break;
        case "VLD":
          cityName = "Valdosta";
          break;
        case "VPS":
          cityName = "Valparaiso";
          break;
        case "WAA":
          cityName = "Wales";
          break;
        case "WBB":
          cityName = "Stebbins";
          break;
        case "WBQ":
          cityName = "Beaver";
          break;
        case "WEF":
          cityName = "Weifang";
          break;
        case "WKJ":
          cityName = "Wakkanai";
          break;
        case "WLK":
          cityName = "Selawik";
          break;
        case "WMO":
          cityName = "White Mountain";
          break;
        case "WNH":
          cityName = "Wenshan";
          break;
        case "WNZ":
          cityName = "Wenzhou";
          break;
        case "WRG":
          cityName = "Wrangell";
          break;
        case "WRL":
          cityName = "Worland";
          break;
        case "WSN":
          cityName = "South Naknek";
          break;
        case "WSX":
          cityName = "Westsound";
          break;
        case "WTK":
          cityName = "Noatak";
          break;
        case "WTL":
          cityName = "Tuntutuliak";
          break;
        case "WUA":
          cityName = "Wuhai";
          break;
        case "WUH":
          cityName = "Wuhan";
          break;
        case "WUS":
          cityName = "Wuyishan";
          break;
        case "WUX":
          cityName = "Wuxi";
          break;
        case "WUZ":
          cityName = "Wuzhou";
          break;
        case "WWP":
          cityName = "North Whale Pass";
          break;
        case "WWT":
          cityName = "Newtok";
          break;
        case "WXN":
          cityName = "Wanxian";
          break;
        case "XFN":
          cityName = "Xiangfan";
          break;
        case "XIC":
          cityName = "Xichang";
          break;
        case "XIL":
          cityName = "Xilinhot";
          break;
        case "XIY":
          cityName = "Xi'an";
          break;
        case "XMN":
          cityName = "Xiamen";
          break;
        case "XNA":
          cityName = "Bentonville";
          break;
        case "XNN":
          cityName = "Xining";
          break;
        case "XUZ":
          cityName = "Xuzhou";
          break;
        case "YAK":
          cityName = "Yakutat";
          break;
        case "YBP":
          cityName = "Yibin";
          break;
        case "YCU":
          cityName = "Yuncheng";
          break;
        case "YGJ":
          cityName = "Miho";
          break;
        case "YIC":
          cityName = "Yichun";
          break;
        case "YIH":
          cityName = "Yichang";
          break;
        case "YIN":
          cityName = "Yining";
          break;
        case "YIW":
          cityName = "Yiwu";
          break;
        case "YKM":
          cityName = "Yakima";
          break;
        case "YNG":
          cityName = "Youngstown";
          break;
        case "YNJ":
          cityName = "Yanji";
          break;
        case "YNT":
          cityName = "Yantai";
          break;
        case "YNZ":
          cityName = "Yancheng";
          break;
        case "YTY":
          cityName = "Yangzhou";
          break;
        case "YUM":
          cityName = "Yuma";
          break;
        case "YUS":
          cityName = "Yushu";
          break;
        case "ZAT":
          cityName = "Zhaotong";
          break;
        case "ZHA":
          cityName = "Zhanjiang";
          break;
        case "ZHY":
          cityName = "Zhongwei";
          break;
        case "ZUH":
          cityName = "Zhuhai";
          break;
        case "TYO":
          cityName = "Tokyo";
          break;

        default:
          cityName = iata;
          break;
      }

      return cityName;
    }


  },
  watch: {
    flexibleDates() {
      if (this.searchable) {
        this[SEARCH_FLIGHTS_ACTION]();
      }
    },
    departureLocation() {
      if (this.searchable) {
        this[SEARCH_FLIGHTS_ACTION]();
      }
    }
  },
  mounted() {
    if (this.searchable
        && !this.$store.state[FLIGHTS_NAMESPACE].flights.searched.length) {
      this[SEARCH_FLIGHTS_ACTION]();
    }
    this[UPDATE_RECOMMENDED_ACTION]();
  }
};
</script>

<style lang="scss">
.trip-flight {

  input[type="radio"],
  input[type="checkbox"],
  input[type="text"] {
    margin-bottom: 0 !important;
    height: auto !important;
  }

  &-departure {
    margin-bottom: 15px;

    &-label {
      color: $color-black;
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 5px;
    }

    .el-select {
      width: 100%;
    }
  }

  &-way {
    margin: 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media (max-width: map_get($media-max, 'xsl')) {
      flex-direction: column;
      align-items: center;
    }

    > button {
      @include red-button;
      text-transform: uppercase;

      min-width: 140px;
      min-height: 45px;

      @media (min-width: map_get($media-min, 'md')) and (max-width: 1199px) {
        font-size: 12px;
        padding: 10px 15px;
      }

      @media (max-width: map_get($media-max, 'xsl')) {
        min-width: 150px;

        &:not(:first-child) {
          margin-top: 15px;
        }
      }
    }

    > div {
      flex-basis: 45%;

      @media (max-width: map_get($media-max, 'xsl')) {
        margin-top: 15px;
      }

      label {
        margin: 0 0 0 10px;
        color: $color-black;
        font-size: 16px;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }

  &-sort {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    @media (max-width: map_get($media-max, 'xs')) {
      flex-direction: column;
      text-align: center;
    }

    > div {
      cursor: pointer;

      @media (max-width: map_get($media-max, 'xs')) {
        margin-top: 10px;
      }

      span {
        color: $color-red;
        font-size: 16px;
        font-weight: normal;
      }

      .fa {
        color: #858585;
        font-size: 16px;

        @media (min-width: map_get($media-min, 'md')) and (max-width: 1199px) {
          margin-left: 0;
        }

        @media (min-width: map_get($media-min, 'xsl')) {
          margin-left: 10px;
        }
      }
    }
  }

  &-details {

    &-reference {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      cursor: pointer;

      &-plane {

        .fa {
          color: $color-red;
        }
      }

      &-text {
        color: $color-red;
        font-size: 10px;
        margin-left: 5px;
      }
    }
  }

  &-list {

    &-item {
      background-color: $color-white;
      border: 1px solid $border-color;

      @media (min-width: map_get($media-min, 'xs')) {
        display: flex;
        align-items: center;
        justify-content: space-around;
      }

      @media (min-width: map_get($media-min, 'xsl')) {
        padding: 15px;
      }

      &:not(:first-child) {
        margin-top: 15px;
      }

      &-container {
        @media (max-width: map_get($media-max, 'xs')) {
          border-bottom: 1px solid $border-color;
        }
      }
    }
  }

  &-change-by-airliners {
    display: flex;
    align-items: center;

    &-label {
      margin-left: 10px;
    }
  }

  &-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: map_get($media-max, 'xsl')) {
      flex-direction: column;
    }

    &:not(:first-child) {
      padding-top: 15px;
    }

    &:not(:last-child) {
      padding-bottom: 15px;
      border-bottom: 1px solid $border-color;
    }

    > div {
      padding: 0 15px;

      @media (min-width: map_get($media-min, 'xsl')) {
        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }
      }
    }

    &-name {
      text-align: center;

      @media (min-width: map_get($media-min, 'xsl')) {
        max-width: 100px;
      }
    }

    &-date {
      color: $color-black;
      font-size: 14px;
      font-weight: normal;

      @media (max-width: map_get($media-max, 'xsl')) {
        order: 2;
        text-align: center;
        margin-top: 10px;
      }

      > div {
        white-space: nowrap;

        @media (max-width: map_get($media-max, 'xsl')) {
          display: inline;
        }
      }
    }

    &-airport {
      flex-basis: 40%;

      @media (max-width: map_get($media-max, 'xsl')) {
        order: 1;
        margin-top: 10px;
      }

      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &-time {
        color: $color-black;
        font-size: 18px;
        font-weight: bold;

        span {
          font-size: 12px;
          margin-left: 10px;
        }

        @media (min-width: map_get($media-min, 'xsl')) {
          > div {
            &:last-child {
              flex-basis: 50%;
            }
          }
        }
      }

      &-name {
        color: $color-red;
        font-size: 18px;
        margin-top: 5px;

        > div {

          &:first-child {
            margin-right: 10px;
          }
        }

        @media (min-width: map_get($media-min, 'xsl')) {
          > div {
            &:last-child {
              flex-basis: 50%;
            }
          }
        }
      }
    }

    &-time {
      color: $color-black;
      font-size: 14px;
      font-weight: normal;
      min-width: 70px;

      @media (max-width: map_get($media-max, 'xsl')) {
        order: 3;
        text-align: center;
      }

      > div {
        @media (max-width: map_get($media-max, 'xsl')) {
          display: inline;
          margin-left: 3px;
        }
      }
    }
  }

  &-price {
    text-align: center;

    @media (max-width: map_get($media-max, 'xs')) {
      margin: 15px 0;
    }

    @media (min-width: map_get($media-min, 'xsl')) {
      padding-left: 15px;
    }

    &-select {
      @include red-button;
      border-radius: 5px;
      padding: 5px 15px;
      margin-top: 5px;
    }

    &-value {
      color: $color-red;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &-empty {

    &-item {
      color: $color-red;
      text-align: center;
      font-size: 16px;
      padding: 15px;
    }
  }
}

.trip-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;

  @media (max-width: map_get($media-max, 'xsl')) {
    flex-direction: column;
  }

  &-count {
    color: $color-black;
    font-size: 14px;
    font-weight: normal;
  }

  .el-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media (max-width: map_get($media-max, 'xsl')) {
      margin-top: 5px;
    }

    .el-pager li, .btn-prev, .btn-next {
      @include red-button;
      border: 1px solid $border-color;
      padding: 10px 5px;
      cursor: pointer;
      min-width: 45px;
      min-height: 45px;
      transition: none;

      @media (max-width: map_get($media-max, 'xs')) {
        font-size: 12px;
        padding: 5px;
        min-width: 30px;
      }

      &:not(:last-child) {
        border-right: none;
      }

      &:not(.disabled) {
        &:hover,
        &:active,
        &.active {
          border-color: $color-red;
        }
      }
    }
  }
}
</style>
